<template>
  <div class="edit-staff-page">
    <div class="fixed-plugin change-pwd">
      <button-change-password
        @showChangePasswordModal="showChangePasswordModal()"
      >
      </button-change-password>
    </div>
    <change-password
      :name="changePasswordModal.name"
      :title="changePasswordModal.title"
      :uuid="uuid"
    ></change-password>

    <staff-infos-form
      ref="infosForm"
      :staffData="staffData"
      @onSubmit="editStaff"
      :serverValidations="serverValidations"
      :isEditPage="true"
    ></staff-infos-form>
  </div>
</template>

<script>
import { service_paths } from "@/constants/Services";
import { convertObj, genErrMsgOj, Message } from "@/helpers/utils";
import { mapState } from "vuex";
import omit from "lodash/omit";
import { getId } from "@/helpers/utils";
import { forbidden_router_name } from "@/routes/routes";
import StaffInfosForm from "../Staffs/StaffInfosForm";
import ChangePassword from "../ChangePassword";
import ButtonChangePassword from "@/components/Base/ButtonChangePassword.vue";

export default {
  components: { ChangePassword, StaffInfosForm, ButtonChangePassword },
  name: "staff-profile",
  data() {
    return {
      staffData: null,
      serverValidations: {},
      uuid: null,
      changePasswordModal: {
        name: "change-password",
        title: "student.change_password"
      }
    };
  },
  computed: {
    ...mapState("user", ["info"]),
    verifyUser() {
      return getId(this.info) === this.staffId;
    },
    staffId() {
      return this.$route.params.id;
    }
  },
  methods: {
    showChangePasswordModal() {
      this.$modal.show(this.changePasswordModal.name);
    },

    mergeAssignedStudent(staffInfo) {
      let assigned_student_response = [];
      staffInfo.assigned_student_information.forEach(item => {
        assigned_student_response.push(item.uuid);
      });
      return assigned_student_response.concat(staffInfo.list_student_assign);
    },

    editStaff(staffInfo) {
      let { updateAvatar, ...staffData } = staffInfo;
      staffData.assigned_student_uuids = [
        ...this.mergeAssignedStudent(staffInfo)
      ];
      staffData = omit(staffData, "list_student_assign");
      const errMsg = this.$t("common.form_invalid");
      this.$axios
        .put(
          `${service_paths.staffs}/${this.staffId}`,
          staffData,
          true,
          {},
          errMsg
        )
        .then(() => {
          const message = updateAvatar
            ? this.$t("common.update_avatar_success")
            : this.$t("common.edit_success");
          Message.success(message);
          this.getStaffData();
        })
        .catch(error => {
          const errData = error.response?.data;

          if (errData) {
            this.serverValidations = genErrMsgOj(errData.messages);
          }
        });
    },

    updateStaffData(formData) {
      return this.$axios
        .put(`${service_paths.staffs}/${this.staffId}`, formData)
        .then(({ data }) => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },

    getStaffData() {
      this.$axios
        .get(`${service_paths.staffs}/${this.staffId}`)
        .then(response => {
          this.staffData = Object.assign(
            { listStudentAssign: [] },
            convertObj.snakeCaseToCamelCase(response.data)
          );
          this.$refs.infosForm.getInitAddress(this.staffData);
          this.uuid = this.staffData.uuid;
        });
    }
  },
  created() {
    this.getStaffData();
    if (!this.verifyUser) {
      this.$router.push({ name: forbidden_router_name });
    }
  }
};
</script>
